<div class="col-12 reviews-pagination">
    <div *ngIf="buttons.length > 1">
<!--        <button [disabled]="currentpage === 0" class="btn btn-link text-primary" (click)="pageClick(currentpage - 1)">-->
<!--            <img src="assets/img/arrow-prev-icon.png" alt="arrow-prev-icon">-->
<!--        </button>-->
        <button class="btn btn-link text-primary" [ngClass]="{'active': button === currentpage}" *ngFor="let button of buttons" (click)="pageClick(button)">
            <span>{{button + 1}}</span>
        </button>
<!--        <button [disabled]="currentpage === buttons.length - 1" class="btn btn-link text-primary" (click)="pageClick(currentpage +1)">-->
<!--            <img src="assets/img/arrow-next-icon.png" alt="arrow-next-icon">-->
<!--        </button>-->

    </div>

</div>
